import { handleActions } from 'redux-actions';
import initialState from './states';
import { logoutSuccess } from 'ducks/auth/actions';
import {
  biTasksByDateSuccess,
  biTasksBySiteAndDateSuccess,
  biTasksBySiteSuccess,
  biTasksScheduleStatisticsSuccess,
  biTasksByEmployeeSuccess,
  biTaskLogSuccess,
  setLoadingState,
} from './actions';

export default handleActions(
  {
    [biTasksBySiteAndDateSuccess](state, { payload }) {
      return {
        ...state,
        bySiteAndDate: payload,
      };
    },
    [biTasksByDateSuccess](state, { payload }) {
      return {
        ...state,
        byDate: payload,
      };
    },
    [biTasksBySiteSuccess](state, { payload }) {
      return {
        ...state,
        bySite: payload,
      };
    },
    [biTasksScheduleStatisticsSuccess](state, { payload }) {
      return {
        ...state,
        scheduleStatistics: payload,
      };
    },
    [biTasksByEmployeeSuccess](state, { payload }) {
      return {
        ...state,
        byEmployee: payload,
      };
    },
    [biTaskLogSuccess](state, { payload }) {
      return {
        ...state,
        list: payload,
      };
    },
    [setLoadingState](state, { payload }) {
      return {
        ...state,
        loading: payload,
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
